import AlertTitle, { AlertTitleProps } from "@mui/material/AlertTitle";

export type { AlertTitleProps };

export default AlertTitle;
